import SoftwareLicenses from "../../../licenses.json";
import "./Licenses.css";

export const Licenses = () => (
  <>
    {SoftwareLicenses.map((license: any) => (
      <div key={license.license} className="u-mb-large">
        <h2>{license.displayName}</h2>
        <div className="c-table-wrapper u-mv">
          <table>
            <thead>
              <tr>
                <th>Komponente</th>
                <th>Version</th>
                <th>Copyright</th>
              </tr>
            </thead>
            <tbody>
              {license.packages.map((pkg: any) => (
                <tr key={pkg.name}>
                  <td>{pkg.name}</td>
                  <td>{pkg.version}</td>
                  <td>{pkg.copyright}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <pre className="b1-license-text b1-text-justify">{license.licenseText}</pre>
      </div>
    ))}
  </>
);
